import { render } from "./kefu.vue?vue&type=template&id=059d7d1f&scoped=true"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"

import "./kefu.vue?vue&type=style&index=0&id=059d7d1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059d7d1f"]])

export default __exports__